// Country-specific configuration for PK, US, NZ, UK
export const COUNTRY_CONFIG = {
  PK: {
    code: 'PK',
    name: 'Pakistan',
    currency: {
      symbol: '₨ ',
      code: 'PKR',
      name: 'Pakistani Rupee',
      decimalPlaces: 2,
      thousandSeparator: ',',
      decimalSeparator: '.'
    },
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '12h',
    numberFormat: {
      thousandSeparator: ',',
      decimalSeparator: '.'
    },
    fields: {
      showStates: false,
      showProvinces: true,
      provinces: [
        { label: 'Punjab', value: 'Punjab' },
        { label: 'Sindh', value: 'Sindh' },
        { label: 'Khyber Pakhtunkhwa', value: 'Khyber Pakhtunkhwa' },
        { label: 'Balochistan', value: 'Balochistan' },
        { label: 'Gilgit-Baltistan', value: 'Gilgit-Baltistan' },
        { label: 'Azad Kashmir', value: 'Azad Kashmir' },
        {
          label: 'Islamabad Capital Territory',
          value: 'Islamabad Capital Territory'
        }
      ]
    }
  },
  US: {
    code: 'US',
    name: 'United States',
    currency: {
      symbol: '$',
      code: 'USD',
      name: 'US Dollar',
      decimalPlaces: 2,
      thousandSeparator: ',',
      decimalSeparator: '.'
    },
    dateFormat: 'MM/DD/YYYY',
    timeFormat: '12h',
    numberFormat: {
      thousandSeparator: ',',
      decimalSeparator: '.'
    },
    fields: {
      showStates: true,
      showProvinces: false,
      states: [
        { label: 'Alaska', value: 'Alaska' },
        { label: 'Alabama', value: 'Alabama' },
        { label: 'Arkansas', value: 'Arkansas' },
        { label: 'Arizona', value: 'Arizona' },
        { label: 'California', value: 'California' },
        { label: 'Colorado', value: 'Colorado' },
        { label: 'Connecticut', value: 'Connecticut' },
        { label: 'District of Columbia', value: 'District of Columbia' },
        { label: 'Delaware', value: 'Delaware' },
        { label: 'Florida', value: 'Florida' },
        { label: 'Georgia', value: 'Georgia' },
        { label: 'Hawaii', value: 'Hawaii' },
        { label: 'Iowa', value: 'Iowa' },
        { label: 'Idaho', value: 'Idaho' },
        { label: 'Illinois', value: 'Illinois' },
        { label: 'Indiana', value: 'Indiana' },
        { label: 'Kansas', value: 'Kansas' },
        { label: 'Kentucky', value: 'Kentucky' },
        { label: 'Louisiana', value: 'Louisiana' },
        { label: 'Massachusetts', value: 'Massachusetts' },
        { label: 'Maryland', value: 'Maryland' },
        { label: 'Maine', value: 'Maine' },
        { label: 'Michigan', value: 'Michigan' },
        { label: 'Minnesota', value: 'Minnesota' },
        { label: 'Missouri', value: 'Missouri' },
        { label: 'Mississippi', value: 'Mississippi' },
        { label: 'Montana', value: 'Montana' },
        { label: 'North Carolina', value: 'North Carolina' },
        { label: 'North Dakota', value: 'North Dakota' },
        { label: 'Nebraska', value: 'Nebraska' },
        { label: 'New Hampshire', value: 'New Hampshire' },
        { label: 'New Jersey', value: 'New Jersey' },
        { label: 'New Mexico', value: 'New Mexico' },
        { label: 'Nevada', value: 'Nevada' },
        { label: 'New York', value: 'New York' },
        { label: 'Ohio', value: 'Ohio' },
        { label: 'Oklahoma', value: 'Oklahoma' },
        { label: 'Oregon', value: 'Oregon' },
        { label: 'Pennsylvania', value: 'Pennsylvania' },
        { label: 'Rhode Island', value: 'Rhode Island' },
        { label: 'South Carolina', value: 'South Carolina' },
        { label: 'South Dakota', value: 'South Dakota' },
        { label: 'Tennessee', value: 'Tennessee' },
        { label: 'Texas', value: 'Texas' },
        { label: 'Utah', value: 'Utah' },
        { label: 'Virginia', value: 'Virginia' },
        { label: 'Vermont', value: 'Vermont' },
        { label: 'Washington', value: 'Washington' },
        { label: 'Wisconsin', value: 'Wisconsin' },
        { label: 'West Virginia', value: 'West Virginia' },
        { label: 'Wyoming', value: 'Wyoming' }
      ]
    }
  },
  NZ: {
    code: 'NZ',
    name: 'New Zealand',
    currency: {
      symbol: 'NZ$',
      code: 'NZD',
      name: 'New Zealand Dollar',
      decimalPlaces: 2,
      thousandSeparator: ',',
      decimalSeparator: '.'
    },
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '12h',
    numberFormat: {
      thousandSeparator: ',',
      decimalSeparator: '.'
    },
    fields: {
      showStates: false,
      showRegions: true,
      regions: [
        { label: 'Auckland', value: 'Auckland' },
        { label: 'Bay of Plenty', value: 'Bay of Plenty' },
        { label: 'Canterbury', value: 'Canterbury' },
        { label: 'Gisborne', value: 'Gisborne' },
        { label: "Hawke's Bay", value: 'Hawkes Bay' },
        { label: 'Manawatu-Wanganui', value: 'Manawatu-Wanganui' },
        { label: 'Marlborough', value: 'Marlborough' },
        { label: 'Nelson', value: 'Nelson' },
        { label: 'Northland', value: 'Northland' },
        { label: 'Otago', value: 'Otago' },
        { label: 'Southland', value: 'Southland' },
        { label: 'Taranaki', value: 'Taranaki' },
        { label: 'Tasman', value: 'Tasman' },
        { label: 'Waikato', value: 'Waikato' },
        { label: 'Wellington', value: 'Wellington' },
        { label: 'West Coast', value: 'West Coast' }
      ]
    }
  },
  UK: {
    code: 'UK',
    name: 'United Kingdom',
    currency: {
      symbol: '£',
      code: 'GBP',
      name: 'British Pound',
      decimalPlaces: 2,
      thousandSeparator: ',',
      decimalSeparator: '.'
    },
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '24h',
    numberFormat: {
      thousandSeparator: ',',
      decimalSeparator: '.'
    },
    fields: {
      showStates: false,
      showCounties: true,
      counties: [
        { label: 'England', value: 'England' },
        { label: 'Scotland', value: 'Scotland' },
        { label: 'Wales', value: 'Wales' },
        { label: 'Northern Ireland', value: 'Northern Ireland' }
      ]
    }
  }
};

// Default country configuration
export const DEFAULT_COUNTRY = 'US';

// Helper function to get country config
export const getCountryConfig = (countryCode) => {
  return COUNTRY_CONFIG[countryCode] || COUNTRY_CONFIG[DEFAULT_COUNTRY];
};

// Helper function to get all supported countries
export const getSupportedCountries = () => {
  return Object.keys(COUNTRY_CONFIG);
};

// Helper function to validate country code
export const isValidCountryCode = (countryCode) => {
  return getSupportedCountries().includes(countryCode);
};
